import api from '@motionelements/core/src/api/base-api-v2';
import Money from '@motionelements/money';

export default {
  namespaced: true,
  // eslint-disable-next-line
  state: () => {
    return {
      plans: [],
    };
  },
  getters: {
    subscriptionCurrency(state) {
      return _.get(state.plans, '[0].price.currency', '');
    },
    subscriptionPlanPriceLabel(state, getters) {
      const price = _.get(state.plans, '[0].price.amount', 0);
      return `${Money({ amount: price, currency: getters.subscriptionCurrency }).getSymbol()} ${price}`;
    },
    freePlanPriceLabel(state, getters) {
      return `${Money({ amount: 0, currency: getters.subscriptionCurrency }).getSymbol()} 0`;
    },
  },
  mutations: {
    setPlans(state, plans) {
      state.plans = plans;
    },
  },
  actions: {
    getSubscriptionPlans({ commit }) {
      return api.get('/v3/subscription-plans')
        .then((response) => {
          console.log(response);
          commit('setPlans', response.data.data);
        })
        .catch((err) => {
          console.log(err);
        });
    },
  },
};
